import { render, staticRenderFns } from "./AddressListRight.vue?vue&type=template&id=34728c8c&scoped=true"
import script from "./AddressListRight.vue?vue&type=script&lang=js"
export * from "./AddressListRight.vue?vue&type=script&lang=js"
import style0 from "./AddressListRight.vue?vue&type=style&index=0&id=34728c8c&prod&lang=css"
import style1 from "./AddressListRight.vue?vue&type=style&index=1&id=34728c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34728c8c",
  null
  
)

export default component.exports